import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ADMIN_AUTH_ROUTES,
  ADMIN_MANAGE_STAFF_ROLES,
} from "../../../constants/adminApiRoutes";
import API from "../../../services/axios";
import { ILogin } from "../../../types/auth";

export const adminLogin = createAsyncThunk(
  ADMIN_AUTH_ROUTES.ADMIN_LOGIN,
  async (data: ILogin, { rejectWithValue }) => {
    try {
      const response = await API.post(ADMIN_AUTH_ROUTES.ADMIN_LOGIN, data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      return response?.data;
    } catch (error: any) {
      if (error?.response && error?.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

export const getUserDetails = createAsyncThunk(
  ADMIN_AUTH_ROUTES.USER_DETAILS,
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get(ADMIN_AUTH_ROUTES.USER_DETAILS);
      return response?.data;
    } catch (error: any) {
      if (error?.response && error?.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

export const getPermission = createAsyncThunk(
  ADMIN_MANAGE_STAFF_ROLES.GET_PERMISSION,
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get(
        `${ADMIN_MANAGE_STAFF_ROLES.GET_PERMISSION}`
      );
      return response?.data;
    } catch (error: any) {
      if (error?.response && error?.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);
